// @flow

import type { StyledButtonProps } from '../types';

export default (icon: boolean, props: StyledButtonProps) => (
  icon ? `${props.theme.buttons.paddingWithIcon[props.size] || props.theme.buttons.paddingWithIcon.default}` : `${props.theme.buttons.padding[props.size] || props.theme.buttons.padding.default}`
);
